const configMap = {
  kr: {
    serviceStartDate: '2023-01-01',

    feature: {
      creditKind: true,
      pricingUnit: true,
      report: true,
      showExchangeRate: false,
      showProjectId: true,
    },

    topNavigation: {
      showAccountId: true,
    },

    billing: {
      commitmentAnalysis: {
        enabled: true,
      },
      costTable: {
        enabled: true,
      },
    },

    bq: {
      accounts: ['015094-17653F-EADCDD', '0137ED-B6B7D7-8B142C'],
    },

    ga: {
      hasGoogleAnalytics: true,
      trackingId: 'G-V48X096BBG',
    },
  },
}

configMap.jp = {
  ...configMap.kr,
  serviceStartDate: '2019-01-01',

  megazoneAccount: {
    url: 'https://start.megazonejapan.jp/',
  },

  currencies: {
    default: 'JPY',
    krw: {
      enabled: false,
    },
    jpy: {
      enabled: true,
    },
  },

  languages: {
    default: 'en',
    korean: {
      enabled: false,
    },
  },

  personal: {
    ipAccessControl: {
      enabled: true,
    },
  },

  timezone: 'America/Los_Angeles',

  ga: {
    hasGoogleAnalytics: false,
  },
}

const config = window.serviceLoc ? configMap[window.serviceLoc] : configMap.kr
export default config
